var app = angular.module("leonardo");

var ReportsDynamicFormListFilters = function(
  $scope,
  $state,
  $timeout,
  $controller,
  ngDialog,
  $rootScope,
  $q,
  ReportService,
  DynamicFormRestService,
  ReportFilterService,
  DeficiencyTagService
) {

  $controller('ReportsFilters', { $scope: $scope });

  $scope.initDynamic = false;

  $scope.filters_valid = ReportService.filtersDynamic;

  $scope.group_options.push({ id: 'managed_by', name: 'Managed By' });

  $scope.dynamicRulesOptions = [];
  $scope.dynamicFieldsOptions = [];
  $scope.deficiencyTagOptions = [];
  $scope.fieldInvalidTypes = ReportFilterService.fieldInvalidTypes;

  $scope.filters_options = [];

  $scope.removeDynamicFields = function() {
    if (!$scope.no_reset_filters || $scope.initDynamic) {
      $scope.filterService.removeFilter('dynamic_filters');
      $scope.filterService.removeFilter('fields_active');
      $scope.filterService.removeFilter('include_tags');
    }
    $scope.dynamicRulesOptions = [];
    $scope.dynamicFieldsOptions = [];
    $scope.deficiencyTagOptions = [];
    $scope.initDynamic = true;
  };

  $scope.updateDynamicFields = function() {
    var defer = $q.defer();
    if (!$scope.filterService.hasFilter('dynamic_form')) {
      $scope.dynamicRulesOptions = [];
      $scope.dynamicFieldsOptions = [];
      $scope.deficiencyTagOptions = [];
      $rootScope.$broadcast('filter-dynamic-form:updated', null);
      defer.resolve();
    }
    else { 
      DynamicFormRestService.get($scope.filterService.getFilter('dynamic_form'), true).then(function (dynamicForm) {
        $rootScope.$broadcast('filter-dynamic-form:updated', dynamicForm);
        var dynamicRules = [];
        var dynamicFields = [];
        angular.forEach(dynamicForm.fields, function(field){
          if(field.children) {
            angular.forEach(field.children, function(child){
              if (!_.contains($scope.fieldInvalidTypes, child.component)) {
                var options = [];
                angular.forEach(child.options, function (option) {
                  var opt = option.value ? option.value : option;
                  options.push(opt);
                });
                var originId = child.originId || child.origin_id;
                var groupId = child.groupId || child.group_id;
                var object = {
                  // id: groupId || child.id,
                  id: child.id,
                  groupId: groupId,
                  originId: originId || child.id,
                  label: child.label,
                  component:child.component,
                  options:options,
                  optionsArray : child.options,
                  section: {
                    id : field.id,
                    label: field.label
                  }
                };
                dynamicRules.push(object);
                dynamicFields.push({id: groupId || child.id, label: child.label });
              }
            });
          }
          else{
            if (!_.contains($scope.fieldInvalidTypes, field.component)) {
              dynamicRules.push(field);
              dynamicFields.push(field);
            }
          }
        });
        $scope.dynamicRulesOptions = dynamicRules;
        $scope.dynamicFieldsOptions = dynamicFields;
        defer.resolve();
      }, function() {
        $scope.filterService.removeFilter('dynamic_form');
      })
    }
    return defer.promise;
  };

  let AccountIdsForIncludeTag = [75, 101, 2733];  // Account Ids for GreyStar, Livcor and White Oak Properties 

  function checkIfAccountExists (MultiAccounts) {
    let isExists = false;
    _.each(MultiAccounts, function(account) {
      if(_.contains(AccountIdsForIncludeTag, account.id)) {
        isExists = true;
      }
    });
    return isExists;
  }

  $scope.initOptions = function() {
    var defer = $q.defer();
    $scope.filters_options = $scope.filters_base.concat([
      {
        id: 'dynamic_form',
        name: 'Dynamic Form',
        label: 'Dynamic Form',
        inline: false,
        type: 'options',
        multiple: false,
        placeholder: 'Select Dynamic Form',
        condition: true,
        service: DynamicFormRestService,
        conflicts: []
      },
      {
        id: 'dynamic_filters',
        name: 'Dynamic Rules',
        label: 'Dynamic Rules',
        inline: false,
        type: 'rules',
        placeholder: 'Select Rules',
        condition: function() {
          return $scope.filterService.hasFilter('dynamic_form');
        },
        options: $scope.dynamicRulesOptions,
        conflicts: []
      },
      {
        id: 'fields_active',
        name: 'Fields To Show',
        label: 'Fields To Show',
        inline: false,
        type: 'columns',
        placeholder: 'Select Fields',
        condition: function() {
          return $scope.filterService.hasFilter('dynamic_form');
        },
        options: $scope.dynamicFieldsOptions,
        conflicts: []
      },
      {
        id: 'workflow_name',
        name: 'Name Workflow',
        label: 'Name Workflow Contains',
        inline: false,
        type: 'text',
        placeholder: 'Name Workflow',
        condition: true,
        conflicts: [],
        onSubmit: $scope.display,
      },
      {
        id: 'triggered_tasks',
        name: 'Triggered Tasks',
        label: 'Triggered Tasks',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'extra_fields',
        name: 'Database Information to Show',
        label: 'Database Information to Show',
        inline: false,
        type: 'columns',
        placeholder: 'Select Fields',
        condition: true,
        options: ReportService.fieldsDynamicFormsReport,
        conflicts: []
      }
    ]);
    if(checkIfAccountExists($scope.filterService.accounts)) {
      let index = $scope.filters_options.findIndex(x => x.id === "dynamic_form");
      $scope.filters_options.splice(index+2, 0, {
        id: 'include_tags',
        name: 'Include Tag',
        label: 'Include Tag',
        inline: false,
        multiple: true,
        type: 'options',
        placeholder: 'Select Tags',
        condition: function() {
          return $scope.filterService.hasFilter('dynamic_form');
        },
        service: DeficiencyTagService,
        serviceFunction: DeficiencyTagService.getIncludeTagsList,
        serviceParams: {'dynamic_form_id' : $scope.filterService.getFilter('dynamic_form')},
        nameField: $scope.authDataService.isAdmin() ? 'tag_name' : 'display_name',
        conflicts: []
      });
    }
    if ($scope.filterService.hasFilter('dynamic_form') && !$scope.initDynamic) {
      $scope.initDynamic = true;
      $scope.updateDynamicFields().then(function() {
        $scope.initOptions();
        defer.resolve();
      });
    }
    else {
      defer.resolve();
    }
    return defer.promise;
  };

  $scope.initOptions();

  $scope.$on('filter-service:filter-changed', function ($event, key) {
    filterupdate(key);
  });

  $scope.$on('filter-service:filter-removed', function ($event, key) {
    filterupdate(key);
  });

  function filterupdate(key) {
    if (key === 'dynamic_form') {
      $scope.removeDynamicFields();
      $scope.updateDynamicFields().then(function () {
        $scope.initOptions();
      });
    }
  }

  if ($scope.filters_name !== 'filters_report' && !ReportService.quick_report) {
    var filters = [];

    if (!$scope.filterService.hasFilter('property_reports')) {
      if (!_.contains(filters,'property_reports')) {
        filters.push('property_reports');
      }
    }

    if (!$scope.filterService.hasFilter('dynamic_form')) {
      if (!_.contains(filters,'dynamic_form')) {
        filters.push('dynamic_form');
      }
    }

    $scope.filterService.setFilter($scope.filters_name, filters, true);
  }

  $rootScope.$broadcast('filters-report:initialized');

  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', ReportService.TYPE_DYNAMIC_FORM);
  }, 100);

};

app.controller('ReportsDynamicFormListFilters', [
  '$scope',
  '$state',
  '$timeout',
  '$controller',
  'ngDialog',
  '$rootScope',
  '$q',
  'ReportService',
  'DynamicFormRestService',
  'ReportFilterService',
  'DeficiencyTagService',
  ReportsDynamicFormListFilters
]);
